import { useState, useEffect, useRef, forwardRef } from 'react';
import styles from './index.module.scss';
import classnames from 'classnames/bind';
import SVG from 'react-inlinesvg';
import { loadJson } from '@autopass-web/domain';
import analytics from './analytics';
const cx = classnames.bind(styles);

const LoveCodeItem = ({ item, isChecked, onClick }) => {
  const itemClass = cx({
    'donate-item': true,
    check: isChecked,
  });

  return (
    <div className={itemClass} onClick={onClick}>
      <div className={styles.content}>
        <div className={styles.code}>愛心碼 {item.love_code}</div>
        <div className={styles.name}>{item.name}</div>
      </div>
      {isChecked && (
        <div className={styles.icon}>
          <SVG src="/assets/check.svg" />
        </div>
      )}
    </div>
  );
};

const setFilterLoveCodeData = (loveCodeData, keyword = '') => {
  let filterData = [];
  if (keyword === '') {
    filterData = loveCodeData;
  } else {
    filterData = loveCodeData.filter((x) => {
      return (
        x.name.indexOf(keyword) !== -1 || x.love_code.indexOf(keyword) !== -1
      );
    });
  }
  return filterData;
};

const FeatureReceiptSettingDonate = forwardRef(
  ({ events, store, loveCodeList, env, className, isShow = true }, ref) => {
    const [text, setText] = useState('');
    const [filterLoveCodes, setFilterLoveCodes] = useState(loveCodeList);
    const inputRef = useRef();

    useEffect(() => {
      if (isShow === false) return;

      analytics.init(env.analyticsKey, env.userId);
      analytics.pageView();
    }, [isShow, env]);

    useEffect(() => {
      if (filterLoveCodes.length === 0) {
        loadJson('/json/love_code.json').then((data) => {
          setFilterLoveCodes(data);
        });
      }

      return () => {
        if (events?.leave) events.leave();
      };
    }, []);

    const onSearchBarChange = (event) => {
      let searchInput = typeof event === 'string' ? event : event.target.value;
      setText(searchInput);
      setFilterLoveCodes(setFilterLoveCodeData(loveCodeList, searchInput));
    };

    const selectLoveCode = (loveCode, name) => {
      analytics.item_onClick({ code: loveCode, unit: name });

      if (store.loveCode !== loveCode) {
        store.setLoveCode(loveCode);
      }
    };

    return (
      <div className={`${styles['donate-page']} ${className}`}>
        <div className={styles['search-bar']}>
          <input
            onFocus={analytics.input_onClick}
            ref={inputRef}
            className={styles['search-input']}
            type="text"
            value={text}
            onChange={onSearchBarChange}
            placeholder="請搜尋愛心碼或團體名稱"
          />
          {text !== '' && (
            <SVG
              width={16}
              height={16}
              src="/assets/close-filled.svg"
              className={styles.clear}
              onClick={() => {
                setText('');
                onSearchBarChange('');
                inputRef.current.focus();
              }}
            />
          )}
        </div>
        <div className={styles['donate-list']} ref={ref}>
          {filterLoveCodes.map((code) => {
            return (
              <LoveCodeItem
                key={code.love_code}
                item={code}
                isChecked={store.loveCode === code.love_code}
                onClick={() => selectLoveCode(code.love_code, code.name)}
              />
            );
          })}
        </div>
      </div>
    );
  },
);

export default FeatureReceiptSettingDonate;
